import React from "react";
import { Route } from "react-router";
import { Switch } from "react-router";
import ListPage from "./pages/admin/ListPage";
import EditPage from "./pages/admin/EditPage";
import CreatePage from "./pages/admin/CreatePage";
import AuthRoute from "../auth/components/routes/AuthRoute";
import NotFound from "../pages/NotFound";
import InfoPage from "./pages/admin/InfoPage";

export default function ServicesAdmin({ path }: { path: string }) {
  return (
    <Route path={path}>
      <Switch>
        <AuthRoute exact path={path} roles={[0, 1]} component={ListPage} />
        <AuthRoute
          roles={[0, 1]}
          component={CreatePage}
          path={`${path}/create`}
        />
        <AuthRoute
          roles={[0, 1]}
          component={EditPage}
          path={`${path}/:id/edit`}
        />
        <AuthRoute roles={[0, 1]} component={InfoPage} path={`${path}/:id/`} />
        <Route path={`${path}/*`} component={NotFound} />
      </Switch>
    </Route>
  );
}
